import { legibleTextColor } from '../lib/contrast';
import { CopyButton } from './CopyButton';
import styles from './Swatch.module.css';

interface SwatchProps {
  color: string;
  selected?: boolean;
  onSelect?: (color: string) => void;
}

/**
 * A single dominant color. The full tile is a button that selects this color as
 * the harmony base; a separate copy button (sibling, not nested) copies the hex.
 */
export function Swatch({ color, selected = false, onSelect }: SwatchProps) {
  // Legible black/white text painted directly on the color — no opacity pill.
  const textColor = legibleTextColor(color);
  return (
    <div
      className={`${styles.swatch}${selected ? ` ${styles.selected}` : ''}`}
      style={{ background: color, color: textColor }}
    >
      <button
        type="button"
        className={styles.select}
        aria-pressed={selected}
        aria-label={`Use ${color} as base color${selected ? ', selected' : ''}`}
        onClick={() => onSelect?.(color)}
      />
      <span className={styles.hex}>{color}</span>
      <CopyButton value={color} className={styles.copy} />
    </div>
  );
}
